// eslint-disable import/no-anonymous-default-export
export default {
  dev: {
    API: {
      baseURL: "https://smile.hutechweb.com/smcs-cp",
      // baseURL: "http://192.168.0.55:8090/smcs-cp",

      bffBaseURL: "https://smcs-dev.hutechweb.com",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      oauthDomain: "SMCS_POOL.auth.us-east-1.amazoncognito.com",
      userPoolWebClientId: "5764umttfqiplob9e337ar0v0m",
      userPoolId: "us-east-1_TD8m0Yrs9",
      region: "us-east-1",
    },
  },
  uat: {
    API: {
      baseURL: "https://smcs-uat.hutechweb.com/smcs-webapp",
      bffBaseURL: "https://smcs-uat.hutechweb.com",
    },
    auth: {
      domain: "smcs-uat.hutechweb.com",
      oauthDomain: "smcs.auth.ap-south-1.amazoncognito.com",
      userPoolWebClientId: "a3e0iaciccfeln7no5b467ab5",
      userPoolId: "ap-south-1_xoRMaTXJu",
      region: "ap-south-1",
    },
  },
  prod: {
    API: {
      baseURL: "https://smcs-cp.hutechweb.com",
      bffBaseURL: "https://smcs-dev.hutechweb.com",
    },
    auth: {
      domain: "smcs-prod.hutechweb.com",
      userPoolWebClientId: "5764umttfqiplob9e337ar0v0m",
      userPoolId: "us-east-1_TD8m0Yrs9",
      region: "us-east-1",
    },
  },
};
